// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__qCvbR","selects":"Documents_selects__2Db1e"};